export default __webpack_public_path__ + "static/O0048-546f9f991e130e6cbc1b6929750b7aff.png";